import { L } from 'harmony-language';
import React from 'react';
import { OrgQueryKeys } from '../../../api/config';
import { useAddOrganizationResourceMutation } from '../../../api/mutations/add/use-add-organization-resource-mutation';
import { useEditOrganizationResourceMutation } from '../../../api/mutations/edit/use-edit-organization-resource-mutation';
import { useOrganizationQuery } from '../../../api/queries/use-organization-query';
import { EditCreateComponentProps, Medication } from '../../../types';
import { ResourcePage } from '../resource-page';
import { EditCreateMedication } from './edit-create-medication';
import { useMedicationColumns } from './use-medication-columns';

export const MedicationManagement = () => {
    const { data: medications, isLoading } = useOrganizationQuery<Medication[]>(OrgQueryKeys.medications);
    const { mutateAsync: addMedication, isLoading: isCreating } = useAddOrganizationResourceMutation(OrgQueryKeys.medications, L.medication());
    const { mutateAsync: editMedication, isLoading: isUpdating } = useEditOrganizationResourceMutation(OrgQueryKeys.medications, L.medication());
    const columns = useMedicationColumns();

    return (
        <ResourcePage
            resourceType='medication'
            isLoading={isLoading || isCreating || isUpdating}
            titleFunc={(medication: Medication) => medication.name}
            data={medications}
            columns={columns}
            EditCreateComponent={(editCreateProps: EditCreateComponentProps<Medication>) =>
                <EditCreateMedication
                    existingMedication={editCreateProps.resource}
                    closeModal={editCreateProps.closeModal}
                    addMedication={addMedication}
                    editMedication={editMedication}
                />
            }
        />
    );
}